/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactPersonDetailsDto } from './contactPersonDetailsDto';
import { TenantPermissions } from './tenantPermissions';
import { AttachmentDetailDto } from './attachmentDetailDto';
import { AddressItemDto } from './addressItemDto';
import { UserItemDto } from './userItemDto';


export interface TenantDetailDto { 
    id: string;
    name: string;
    description: string;
    type: TenantDetailDto.TypeEnum;
    contractDate?: string;
    email: string;
    phone: string;
    paymentAddress?: AddressItemDto;
    permissions: TenantPermissions;
    color: string;
    pin?: string;
    smallLogo?: AttachmentDetailDto;
    largeLogo?: AttachmentDetailDto;
    homePage: string;
    companyRegisterNumber: string;
    iban: string;
    bic: string;
    court: string;
    worksWithOenorm?: boolean;
    signature?: AttachmentDetailDto;
    certificateTitle?: string;
    signatureName?: string;
    longListTitle?: string;
    nameAddition: string;
    contactPerson?: UserItemDto;
    embeddedContactPerson?: ContactPersonDetailsDto;
    restrictedToAssignedExternalTenants?: boolean;
    corporateGroupId?: string;
    corporateGroupName?: string;
    assignedExternalTenantIds?: Array<string>;
    catalogSourceTenantId?: string;
    catalogSourceTenantName?: string;
    hiddenInspectionPdfTypes?: Set<TenantDetailDto.HiddenInspectionPdfTypesEnum>;
    emailRequiredInspectionPdfTypes?: Set<TenantDetailDto.EmailRequiredInspectionPdfTypesEnum>;
    horaPassInspectionPdfTypes?: Set<TenantDetailDto.HoraPassInspectionPdfTypesEnum>;
    allowIncompleteInspectionUpload?: boolean;
    usesRiskAssessmentByDefault?: boolean;
}
export namespace TenantDetailDto {
    export type TypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TypeEnum = {
        Internal: 'Internal' as TypeEnum,
        External: 'External' as TypeEnum,
        Contractor: 'Contractor' as TypeEnum
    };
    export type HiddenInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const HiddenInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as HiddenInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as HiddenInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as HiddenInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as HiddenInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as HiddenInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as HiddenInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as HiddenInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as HiddenInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as HiddenInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as HiddenInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as HiddenInspectionPdfTypesEnum
    };
    export type EmailRequiredInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const EmailRequiredInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as EmailRequiredInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as EmailRequiredInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as EmailRequiredInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as EmailRequiredInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as EmailRequiredInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as EmailRequiredInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as EmailRequiredInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as EmailRequiredInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as EmailRequiredInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as EmailRequiredInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as EmailRequiredInspectionPdfTypesEnum
    };
    export type HoraPassInspectionPdfTypesEnum = 'SHORTLIST' | 'LONGLIST' | 'COVERSHEET' | 'BUILDING_EQUIPMENTS' | 'CERTIFICATE_SHEET' | 'REPAIR_TASK_SHORTLIST' | 'BUILDING_EQUIPMENTS_SCHLOSS' | 'CERTIFICATE_SHEET_SCHLOSS' | 'OBJECT_SAFETY_REPORT' | 'SCHADSTELLENPLAN' | 'OBJECT_SAFETY_LIST';
    export const HoraPassInspectionPdfTypesEnum = {
        Shortlist: 'SHORTLIST' as HoraPassInspectionPdfTypesEnum,
        Longlist: 'LONGLIST' as HoraPassInspectionPdfTypesEnum,
        Coversheet: 'COVERSHEET' as HoraPassInspectionPdfTypesEnum,
        BuildingEquipments: 'BUILDING_EQUIPMENTS' as HoraPassInspectionPdfTypesEnum,
        CertificateSheet: 'CERTIFICATE_SHEET' as HoraPassInspectionPdfTypesEnum,
        RepairTaskShortlist: 'REPAIR_TASK_SHORTLIST' as HoraPassInspectionPdfTypesEnum,
        BuildingEquipmentsSchloss: 'BUILDING_EQUIPMENTS_SCHLOSS' as HoraPassInspectionPdfTypesEnum,
        CertificateSheetSchloss: 'CERTIFICATE_SHEET_SCHLOSS' as HoraPassInspectionPdfTypesEnum,
        ObjectSafetyReport: 'OBJECT_SAFETY_REPORT' as HoraPassInspectionPdfTypesEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as HoraPassInspectionPdfTypesEnum,
        ObjectSafetyList: 'OBJECT_SAFETY_LIST' as HoraPassInspectionPdfTypesEnum
    };
}


